var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image", class: _vm.getVariant("image") }, [
    _c("div", { staticClass: "image__wrapper" }, [
      _c("picture", [
        _c("source", {
          attrs: { media: "--small", "data-srcset": _vm.mobileImageId }
        }),
        _c("source", {
          attrs: { media: "--large", "data-srcset": _vm.imageId }
        }),
        _c("img", {
          staticClass: "lazyload",
          attrs: { "data-sizes": "auto", "data-src": _vm.imageId }
        })
      ])
    ]),
    _c("div", { staticClass: "image__header" }, [
      _c(
        "div",
        { staticClass: "image__header__subtitle" },
        [_vm._t("title-small")],
        2
      ),
      _c(
        "div",
        { staticClass: "image__header__title" },
        [_vm._t("title-normal")],
        2
      )
    ]),
    _c("div", { staticClass: "image__footer" }, [
      _c(
        "div",
        { staticClass: "image__footer__skills" },
        [
          _c(
            "div",
            { staticClass: "image__footer__skills__title" },
            [_vm._t("skill-title")],
            2
          ),
          _vm._l(_vm.skills, function(skill) {
            return [_vm._t("skill", null, { skill: skill })]
          })
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "image__footer__icon image__footer__icon--left" },
        [_c("icon-scroll-view")],
        1
      ),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "image__footer__icon image__footer__icon--bottom" },
      [_c("i", { staticClass: "icon-arrow animation-jump" })]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8a408ca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8a408ca","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/image/image-view.vue
// module id = 522
// module chunks = 84